// components/layouts/PageLayout.tsx
import React from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import TopHeader from '../layouts/TopHeader';
import DashboardHeader from '../layouts/DashboardHeader';

interface PageLayoutProps {
    children: React.ReactNode;
    onRefresh?: () => Promise<void | unknown>;
    className?: string;
    headerName?: string;
    onlyTitle?: boolean;
    showMenuOption?: boolean;
    showHeader?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
    children,
    onRefresh,
    className = '',
    headerName,
    onlyTitle = true,
    showMenuOption = true,
    showHeader = true,
}) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    // Let children tell layout when modal is open
    const enhancedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child as any, {
                setLayoutModalOpen: setIsModalOpen,
            });
        }
        return child;
    });

    return (
        <div
            className={`dashboard-page pb-4 ${className}`}
            style={{ overflow: 'auto' }}
        >
            {showHeader &&
                <TopHeader
                    headerName={headerName}
                    onlyTitle={onlyTitle}
                    showMenuOption={showMenuOption}
                />
            }
            {onRefresh && !isModalOpen ? (
                <PullToRefresh onRefresh={onRefresh}>
                    <main id="main-content">{enhancedChildren}</main>
                </PullToRefresh>
            ) : (
                <main id="main-content">{enhancedChildren}</main>
            )}
        </div>
    );
};


export default PageLayout;
